import type { ReactNode } from 'react'
import { useExpert } from '@/hooks/useExpert'

export type FactRow = [string, ReactNode]

// 이름·값 목록. expert 행은 전문가가 켜졌을 때 같은 목록의 뒤에 이어진다 — 별도 상자가 아니다.
export function Facts({ rows, expert = [] }: { rows: FactRow[]; expert?: FactRow[] }) {
  const { on } = useExpert()
  const shown = on ? [...rows, ...expert] : rows
  if (shown.length === 0) return null
  return (
    <dl className="grid grid-cols-[140px_minmax(0,1fr)] gap-x-4 gap-y-1.5 text-[12px] max-sm:grid-cols-[92px_minmax(0,1fr)] max-sm:gap-x-3">
      {shown.map(([k, v]) => (
        <div key={k} className="contents">
          <dt className="text-muted-foreground">{k}</dt>
          <dd className="min-w-0 break-words">{v}</dd>
        </div>
      ))}
    </dl>
  )
}
